export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7074.fe9ace5c.jpg";